<template lang="pug">
  .flexible(v-bind:style="{ height: height }")
    slot
</template>

<script>
export default {
  props: ['height']
}
</script>

<style lang="scss">
  .flexible {
    display:flex;
    justify-content: space-between;
    flex-direction: row;
    &.center {
      align-items: center;
      justify-content: center;
      &.text-left {
        justify-content: left;
      }
      &.text-right {
        justify-content: right;
      }
      small {
        line-height:0;
      }
    }
    &.jleft {
      justify-content: left;
    }
    &.jright {
      justify-content: right;
    }
    .col {
      &.pd-l {
        padding-left:10px;
      }
      &.mr {
        margin-right:10px;
      }
      &.ml {
        margin-left:10px;
      }
      &.mg-top {
        margin-top:10px;
      }
      &.center {
        justify-content: center;
        align-items:center;
      }
      width:100%;
      &.small {
        width:45%;
        max-width:370px;
      }
      &.box {
        width:58px;
      }
    }
  }
</style>